import { render } from "./areas.vue?vue&type=template&id=786c7430"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/areas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "786c7430"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('786c7430', __exports__)) {
    api.reload('786c7430', __exports__)
  }
  
  module.hot.accept("./areas.vue?vue&type=template&id=786c7430", () => {
    api.rerender('786c7430', render)
  })

}


export default __exports__